import axios, { AxiosResponse } from 'axios';
import { UserRoles } from '../auth/auth.model';
import { whoAmI } from '../auth/auth.service';

const routeName = `/sites`;
export async function getSites(): Promise<any> {
    let  urlRoute = routeName;
    const filter = {
        where: {
        },
        "include": [
          {
            "relation": "guestCategories",
            "scope":{
                "include": [
                  {
                    "relation": "questions"
                  }
                ]
            }
          }
        ]
      };
    //for admin, get ALL sites
    if (localStorage.getItem('user-role') === UserRoles.SITEMNGR.key){
        const res = await whoAmI();
        urlRoute = '/users/'+ res.data.id + routeName;
    }

    return axios.get(process.env.VUE_APP_CJ_API_URL + urlRoute/*+'?filter='+JSON.stringify(filter)*/)
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getSites !',err);
            return {error : err};
        });
}

export async function postSite(data: any): Promise<any> {
    if (localStorage.getItem('user-id')){
        data.ownerId = parseInt(localStorage.getItem('user-id')+'');
    }else {
        delete data.ownerId;
    }
    return axios.post(process.env.VUE_APP_CJ_API_URL + routeName,data)
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error postSite !',err);
            return {error : err};
        });
}

export async function patchSite(siteId: number,data: any): Promise<any> {
    if (data.updatedAt) delete data.updatedAt;
    if (data.createdAt) delete data.createdAt;
    if (!data.ownerId) delete data.ownerId;
    if (!data.logoUrl) delete data.logoUrl;
    if (data.guestCategories) delete data.guestCategories;
    return axios.patch(process.env.VUE_APP_CJ_API_URL + routeName+'/'+siteId,data)
        .then(resp => {
            return {data: 'success'};
        })
        .catch(err => {
            console.log('error patchSite !',err);
            return {error : err};
        });
}

export async function deleteSites(dataToDelete: any[]): Promise<any> {
    const successData: any[] = [];
    const errorData: any[]= [];
    for (const prop in dataToDelete) {
        const data = dataToDelete[prop];

        await axios.delete(process.env.VUE_APP_CJ_API_URL +routeName+'/'+data.id)
            .then(resp => {
                successData.push(data);
            })
            .catch(err => {
                errorData.push(data);
                console.log('error deleteSites',err);
            });
        }
    return {data: {successData: successData },
            error: {errorData: errorData}};
}